<template>
  <div class="contact-company-page">
    <Banner :bannerUrl="bannerUrl" :title="$t('contactCompanyPage.bannerTitle')" />
    <div class="container">
      <div class="contact-list fb">
        <div class="list-item fcc" v-for="(item, index) in contactList" :key="index">
          <div>
            <img :src="item.img">
          </div>
          <div class="name">{{ item.name }}</div>
          <div v-if="item.phone" class="phone">{{ item.phone }}</div>
          <div class="email">{{ item.email }}</div>
        </div>
      </div>
      <!-- 留言建议 -->
       <div class="suggest-form" v-if="false">
          <div class="title">留言建议</div>
          <a-form
            :model="formState"
            name="basic"
            labelAlign="left"
            layout="vertical"
            autocomplete="off"
            @finish="onFinish"
            @finishFailed="onFinishFailed"
          >
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item
                  label="公司名称："
                  name="username"
                  :rules="[{ required: true, message: '请输入公司名称' }]"
                >
                  <a-input v-model:value="formState.username" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  label="姓名"
                  name="username"
                  :rules="[{ required: true, message: '请输入姓名' }]"
                >
                  <a-input v-model:value="formState.username" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  label="电话"
                  name="username"
                  :rules="[{ required: true, message: '请输入电话' }]"
                >
                  <a-input v-model:value="formState.username" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  label="邮箱"
                  name="username"
                  :rules="[{ required: true, message: '请输入邮箱' }]"
                >
                  <a-input v-model:value="formState.username" />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item
                  label="留言"
                  name="username"
                  :rules="[{ required: true, message: '请输入留言' }]"
                >
                  <a-textarea v-model:value="formState.username" :rows="4" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  label="验证码"
                  name="username"
                  :rules="[{ required: true, message: '请输入验证码' }]"
                >
                  <a-input v-model:value="formState.username" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  style="text-align: right;"
                >
                  <a-button class="submit-btn" type="primary">发送</a-button>
                </a-form-item>
              </a-col>
           
              </a-row>
          </a-form>
       </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import Banner from '@/components/banner'
const formState = ref({});
const bannerUrl = require('@assets/images/banner/banner-contact-company.png');
const contactList = [
  {
    img: require('@assets/icons/ico-contact-company_1.svg'),
    name: t('contactCompanyPage.contactWay1.name'),
    email: t('email') + '：info@hstocean.com'
  },
  {
    img: require('@assets/icons/ico-contact-company_2.svg'),
    name: t('contactCompanyPage.contactWay2.name'),
    email: t('email') + '：info@hstocean.com'
  },
  {
    img: require('@assets/icons/ico-contact-company_3.svg'),
    name: t('contactCompanyPage.contactWay3.name'),
    email: t('email') + '：info@hstocean.com'
  },
]
</script>


<style lang="less" scoped>
.contact-company-page {
  margin-bottom: 223px;
  /deep/ .com-banner .banner_title {
    left: 50%;
    transform: translate(-50%, 40px);
    font-size: 32px;
  }
  .container {
    margin-top: 83px;
    .contact-list {
      gap: 25px;
      .list-item {
        flex: 1;
        height: 228px;
        padding: 35px 35px;
        border-radius: 8px;
        background: #F4F9FF;
        img {

        }
        .name {
          color: #343943;
          font-size: 18px;
          font-weight: 600;
          line-height: 46px;
          margin-top: 14px;
        }
        .phone, .email {
          color: #7D7D7D;
          font-size: 16px;
          line-height: 16px;
          margin-top: 10px;
        }
        .phone {
          margin-top: 12px;
        }
      }
    }
    .suggest-form {
      margin-top: 66px;
      border-radius: 8px;
      background: #F7F7F7;
      padding: 30px 145px 53px 145px;
      .title {
        color: #000;
        font-size: 24px;
        font-weight: 600;
        text-align: center;
      }
      /deep/ .ant-form {
        margin-top: 30px;
        .ant-form-item {
          margin-bottom: 340x;
          .ant-form-item-label >label {
            color: #25262C;
            font-size: 14px;
          }
        }
        .ant-form-item-control .ant-form-item-control-input-content .ant-input {
          height: 42px;
          border-radius: 4px;
          font-size: 14px;
          border: 1px solid #DBDBDB;
        }
        .submit-btn {
          width: 234px;
          height: 54px;
          font-size: 16px;
          margin-top: 25px;
        }
      }
    }
  }
}
</style>